/**
 * Safari в браузере на iPhone (не in-app WebView и не Chrome/Firefox на iOS).
 * Тот же детект, что использует страница instruction.
 */
export function isMobileSafari(): boolean {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent;
  if (!/iPhone/.test(ua)) return false;

  return (
    /Safari/.test(ua) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/.test(ua)
  );
}
